// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__ZqFQE","left":"styles_left__ym5_U","logoLink":"styles_logoLink__oOgK7","logo":"styles_logo___sSGJ"};